import { fetchEndpoint } from '../network'

/**
 * 优惠券管理
 */

export default {

    // 优惠券列表
    list (params) {
      return fetchEndpoint(
        '/create-platform/coupons',
        'GET',
        params
      )
    },

    // 创建
    create(params) {
      return fetchEndpoint(
        '/create-platform/coupons',
        'POST',
        params
      )
    },

    // 详情
    detail(params) {
      return fetchEndpoint(
        '/create-platform/coupons/' + params.id,
        'GET',
        params
      )
    },

    // 修改
    modify(params) {
      return fetchEndpoint(
        '/create-platform/coupons/' + params.id,
        'PUT',
        params
      )
    },

    // 核销列表
    verified(params) {
      return fetchEndpoint(
        '/create-platform/coupon/codes/merchant/verified',
        'GET',
        params
      )
    },

    // 更新状态
    isStatus(params) {
      return fetchEndpoint(
        '/create-platform/coupons/'+ params.id +'/status',
        'PUT',
        params
      )
    },

    remove(params) {
      return fetchEndpoint(
        '/create-platform/coupons/' + params.id,
        'DELETE',
        params
      )
    },

    // 核销列表
    codes(params) {
      return fetchEndpoint(
        '/create-platform/coupon/'+ params.id +'/codes',
        'GET',
        params
      )
    },

    // 核销券码
    verify(params) {
      return fetchEndpoint(
        '/create-platform/coupon/codes/verify',
        'PUT',
        params
      )
    },

    // 作废券码
    discard(params) {
      return fetchEndpoint(
        '/create-platform/coupon/codes/discard',
        'PUT',
        params
      )
    },

    // 导出
    couponExport(params) {
      return fetchEndpoint(
        '/create-platform/coupon/codes/export',
        'GET',
        params
      )
    },

    // 删除券码
    removeCouponCode(params) {
      return fetchEndpoint(
        '/create-platform/coupon/codes',
        'DELETE',
        params
      )
    },

    // 商品选择
    youzanGoods(params) {
      return fetchEndpoint(
        '/youzan/list/right',
        'POST',
        params
      )
    },

    // 操作日志列表
    // verified(params) {
    //   return fetchEndpoint(
    //     '/coupon/codes/verified',
    //     'GET',
    //     params
    //   )
    // },

}









 